import { connect } from 'react-redux';
import { styles } from '../../containers/dockPadStyle'
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { lookaheadActions } from '../../actions/lookahead.actions';

import { 
    getConstraints, 
    getTradesSelectList, 
    getConstraintSelectList, 
    getTrades,
    getTagSelectList,
    getConstraintId,
    getConstraint,
    getSelectedPhasePlan,
    getSelectedPhasePlanId
} from '../../selectors/phaseplan.selector'

import { isConstraintDialogOpen } from '../../selectors/dialog.selector'

import {
    getLookaheadTagSelectList,
    getLookaheadTagLocationsSelectList,
    getLookaheadTagId,
    getLookaheadTag,
    selectType
} from '../../selectors/lookahead.selector'

import { getProjectId, getProjectUsersList } from '../../selectors/project.selector';
import { alertActions } from '../../actions/alert.actions';
import { LookaheadTag } from '../../models/LookaheadTag';
import { ThunkDispatch } from 'redux-thunk';
import ConstraintDialog from './ConstraintDialog';
import { dialogActions } from '../../actions/dialog.actions';
import { phasePlanActions } from '../../actions/phaseplan.actions';
import { Constraint } from '../../models/Constraint';
import { firebaseConnect } from 'react-redux-firebase';
import { ColumnType } from '../PhasePlan/Column';

const mapStateToProps = (state: any, ownProps?: any) => ({
    isConstraintDialogOpen: isConstraintDialogOpen(state),
    tradesSelectList: getTradesSelectList(state),
    tagSelectList: getTagSelectList(state),
    tagLocationsSelectList: getLookaheadTagLocationsSelectList(state),
    constraintSelectList: getConstraintSelectList(state),
    projectId: getProjectId(state),
    trades: getTrades(state),
    constraintToEdit: getConstraint(state),
    constraintToEditId: getConstraintId(state),
    constraints: getConstraints(state),
    projectUsers: getProjectUsersList(state),
    type: selectType(state, ownProps)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
    closeDialogValue: () => dispatch(dialogActions.closeConstraintDialog()),
    submitValue: (type: ColumnType, constraint:Constraint, constraintId?: string) => 
        dispatch(phasePlanActions.saveConstraint( type, constraint, constraintId)),
    errorAlert: (message: string) => dispatch(alertActions.error(message))
});


export default compose(
    connect(state => {
        return {
            projectId: getProjectId(state),
            phaseId: getSelectedPhasePlanId(state)
        };
    }),
    firebaseConnect((props:any) => {
          
          if(!props.projectId || !props.phaseId) {
              return []
          }
          return [
              {
                  path: `projects/${props.projectId}/phases/${props.phaseId}/tags`,
                  storeAs: 'SELECTED_PHASE_TAGS'
              }
          ];
    }),
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles, { withTheme: true })
)(ConstraintDialog)


// WEBPACK FOOTER //
// ./src/components/Dialogs/ConstraintDialogContainer.ts